/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnrollmentScheduleDto } from '../../models/enrollment-schedule-dto';

export interface EnrollmentScheduleControllerFindByTicketIdV1$Params {
  ticketId: string;
}

export function enrollmentScheduleControllerFindByTicketIdV1(http: HttpClient, rootUrl: string, params: EnrollmentScheduleControllerFindByTicketIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EnrollmentScheduleDto>>> {
  const rb = new RequestBuilder(rootUrl, enrollmentScheduleControllerFindByTicketIdV1.PATH, 'get');
  if (params) {
    rb.query('ticketId', params.ticketId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EnrollmentScheduleDto>>;
    })
  );
}

enrollmentScheduleControllerFindByTicketIdV1.PATH = '/api/v1/enrollment-schedule/ticket';
